import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
// import kebabCase from 'lodash.kebabcase';
import {
  ColoredHeading,
  CompHeading,
  SidebarHeading,
  PageHeader,
  DangerousWrapper,
  makeBreadcrumb,
  clip,
  stripHTML
  // ,SimpleDataTable
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

import './generic.scss';

const GenericPage = (props) => {
  const {
    content, content: { data }, site
    // eslint-disable-next-line react/destructuring-assignment
  } = props.data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;
  const { pageContext } = props;
  const {
    title, shortTitle, category, sections
  } = pageContext;
  const hasTitle = data && data[0].content && data[0].name === 'h1';
  // If the first component in JSON data is not an h1, then use the title declared in the meta data
  const pageTitle = hasTitle ? data[0].content : title;
  const { breadcrumbprops } = sections ? makeBreadcrumb({
    sections: [...sections, pageTitle]
  }) : { breadcrumbprops: null };
  const layoutProps = {
    activeIndex: 0,
    above: () => pageTitle && <PageHeader title={pageTitle} category={category} />,
    pageTitle: shortTitle || pageTitle,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  if (sections) {
    layoutProps.breadcrumbprops = breadcrumbprops;
  }
  // metadata for the page
  let summary;
  if (data) {
    const firstParagraph = data.find((item) => item.name === 'p');
    const firstNonHeading = data.find((item) => !item.name.match(/^h[0-9]/));
    if (firstParagraph) {
      summary = firstParagraph.content;
    } else {
      summary = firstNonHeading.content;
    }
  }
  const metaTitle = category ? `${category}: ${pageTitle}` : pageTitle;
  const metaDescription = summary ? clip(stripHTML(summary), 160) : metaTitle;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {
          content.data.map((component, i) => {
            const {
              name, content: text, src, alt, maxWidth
              // , table
            } = component;
            const key = `genericComponent${i}`;
            switch (name) {
              case 'h1':
                return(null);
              case 'h2':
                return(<ColoredHeading text={text} key={key} />);
              case 'h2 summary':
                return(<SidebarHeading title={text} key={key} />);
              case 'h3':
                return(<CompHeading level={3} title={text} key={key} />);
              case 'h4':
                return(<CompHeading level={4} title={text} color="yellow" key={key} />);
              case 'h5':
                return(<CompHeading level={5} title={text} color="gray" key={key} />);
              case 'img':
                return(<Img fluid={src.childImageSharp.fluid} key={key} alt={alt} style={{ maxWidth: Number(maxWidth), textAlign: 'center', margin: '0 auto' }} />);
              case 'table':
                return(<DangerousWrapper className="richtext" rawHtml={text} key={key} />);
                // return(<SimpleDataTable table={table} />);
              default:
                return(<DangerousWrapper className="richtext" rawHtml={text} key={key} htmlTag={name} />);
            }
          })
        }
      </Layout>
    </Fragment>
  );
};

GenericPage.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object
};

export default GenericPage;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: genericJson(fields: {slug: {eq: $slug }}) {
    id
    title
    data {
      name
      content
      alt
      maxWidth
      src {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      # table {
      #   data {
      #     col0
      #     col1
      #     col2
      #     col3,
      #     col4
      #   }
      #   headers {
      #     name
      #     value
      #     type
      #     align
      #   }
      # }
    }

    # Get the last modified timestamp for the file powering the generic pages.
    ...GenericJsonDataTimeStamp
  }
}

`;
